var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.168 19.3652H7.20703C5.99533 19.3652 5.00977 18.3797 5.00977 17.168V7.20703C5.00977 5.99533 5.99533 5.00977 7.20703 5.00977H17.168C18.3797 5.00977 19.3652 5.99533 19.3652 7.20703V17.168C19.3652 18.3797 18.3797 19.3652 17.168 19.3652ZM7.20703 6.47461C6.80317 6.47461 6.47461 6.80317 6.47461 7.20703V17.168C6.47461 17.5718 6.80317 17.9004 7.20703 17.9004H17.168C17.5718 17.9004 17.9004 17.5718 17.9004 17.168V7.20703C17.9004 6.80317 17.5718 6.47461 17.168 6.47461H7.20703ZM3.54492 13.5059H2.8125C2.40864 13.5059 2.08008 13.1773 2.08008 12.7734V2.8125C2.08008 2.40864 2.40864 2.08008 2.8125 2.08008H12.7734C13.1773 2.08008 13.5059 2.40864 13.5059 2.8125V3.5083H14.9707V2.8125C14.9707 1.6008 13.9851 0.615234 12.7734 0.615234H2.8125C1.6008 0.615234 0.615234 1.6008 0.615234 2.8125V12.7734C0.615234 13.9851 1.6008 14.9707 2.8125 14.9707H3.54492V13.5059Z",
    fill: "#777E8A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.8cce632c518faef33bd7da6ca2940b8c.svg";
export { ForwardRef as ReactComponent };